import Svg, { SvgProps, Path } from 'react-native-svg'

const Thumb = (props: SvgProps) => (
  <Svg
    width={props.width ?? 33}
    height={props.height ?? 33}
    viewBox="0 0 33 33"
    {...props}
    fill="none"
  >
    <Path
      stroke="#2F3133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.667}
      d="m20.5 7.841-1.333 5.494h7.773a2.666 2.666 0 0 1 2.56 3.413l-3.106 10.667a2.667 2.667 0 0 1-2.56 1.92h-18a2.667 2.667 0 0 1-2.667-2.667V16.001a2.667 2.667 0 0 1 2.667-2.666h3.68a2.666 2.666 0 0 0 2.386-1.48l4.6-9.187a4.173 4.173 0 0 1 4 5.173Z"
      fill={props.fill}
    />
    <Path
      stroke="#2F3133"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.667}
      d="M9.833 13.332v16"
    />
  </Svg>
)
export default Thumb
